(function () {
    var hdr = document.querySelector('[data-kn-header]');
    if (!hdr) return;
    function setH() {
      var h = hdr.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--header-height', h + 'px');
      document.documentElement.style.setProperty('--kn-header-h', h + 'px');
    }
    setH();
    window.addEventListener('resize', setH);
    if (window.ResizeObserver) new ResizeObserver(setH).observe(hdr);

    var drawer = hdr.querySelector('[data-kn-drawer]');
    var openBtn = hdr.querySelector('[data-kn-open]');
    function toggle(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('kn-lock', open);
    }
    openBtn.addEventListener('click', function () { toggle(true); });
    hdr.querySelectorAll('[data-kn-close]').forEach(function (el) { el.addEventListener('click', function () { toggle(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') toggle(false); });

    var form = hdr.querySelector('[data-kn-search]');
    var input = form.querySelector('[data-kn-search-input]');
    var box = form.querySelector('[data-kn-suggest]');
    var timer;
    function money(c) { try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD' }).format(c); } catch (e) { return c; } }
    function render(items, q) {
      if (!items.length) { box.innerHTML = '<p class="kn-suggest__empty">No results for “' + q.replace(/</g, '&lt;') + '”</p>'; box.hidden = false; return; }
      box.innerHTML = items.map(function (p) {
        var img = p.image ? '<img src="' + p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : '';
        return '<a class="kn-suggest__item" href="' + p.url + '">' + img + '<span><strong>' + p.title.replace(/</g, '&lt;') + '</strong><em>' + (p.price ? 'From ' + money(parseFloat(p.price)) : '') + '</em></span></a>';
      }).join('') + '<a class="kn-suggest__all" href="' + form.action + '?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
      box.hidden = false;
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(function () {
        fetch((hdr.getAttribute('data-predictive-url') || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products || []).map(function (p) {
              return { title: p.title, url: p.url, image: p.image, price: p.price };
            });
            render(items, q);
          }).catch(function () { box.hidden = true; });
      }, 200);
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
  })();
